import React, { useRef } from "react";
import "./Carousel.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/effect-fade";

function Carousel() {
  const swiperRef = useRef(null);

  return (
    <div className="slider-container">
      <Swiper
        modules={[EffectFade, Autoplay]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        slidesPerView={1}
        loop={true}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        className="swipers"
      >
        <SwiperSlide className="swiper1">
          <video
            className="background-video"
            src="/video/header_video_bg.mp4"
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="overlay"></div>
          <div className="slide_content">
            <img src="/images/artel_logo.png" alt="" />
            <p>
              Experience the future of transportation. Fast. Reliable. Secure.
            </p>
            <Link to="/about" className="to_about_link">
              Learn More
            </Link>
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper2">
          <div className="overlay"></div>
          <div className="slide_content">
            <img src="/images/artel_logo.png" alt="" />
            <p>Modern logistics infrastructure for maximum efficiency</p>
            <Link to="/about" className="to_about_link">
              Learn More
            </Link>
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper3">
          <div className="overlay"></div>
          <div className="slide_content">
            <img src="/images/artel_logo.png" alt="" />
            <p>From coast to coast, we've got you covered.</p>
            <Link to="/about" className="to_about_link">
              Learn More
            </Link>
          </div>
        </SwiperSlide>
      </Swiper>

      <button
        className="custom-prev"
        onClick={() => swiperRef.current && swiperRef.current.slidePrev()}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 6l-6 6 6 6"
          />
        </svg>
      </button>

      <button
        className="custom-next"
        onClick={() => swiperRef.current && swiperRef.current.slideNext()}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 6l6 6-6 6"
          />
        </svg>
      </button>
    </div>
  );
}

export default Carousel;
